import React from 'react';
import {Space, Spin, Tooltip} from 'antd';
import classNames from 'classnames';
import styles from './index.less';

interface ColumnProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  loading?: boolean;
  children?: React.ReactNode;
}

export const CascaderColumn: React.FC<ColumnProps> = ({ icon, title, loading, children }) => (
  <div className={styles.column}>
    <Space className={styles.columnTitle}>
      {icon}
      <span>{title}</span>
    </Space>
    <div className={styles.optionsContainer}>
      {loading ? (
        <div className={styles.spinnerWrapper}>
          <Spin size="small" />
        </div>
      ) : (
        children
      )}
    </div>
  </div>
);

interface OptionProps {
  selected?: boolean;
  selectedAgent?: boolean;
  tooltip?: string;
  onClick?: () => void;
  suffix?: React.ReactNode;
  children: React.ReactNode;
}

export const CascaderOption: React.FC<OptionProps> = ({
  selected,
  selectedAgent,
  tooltip,
  onClick,
  suffix,
  testid,
  children,
}) => {
  const el = (
    <div
      data-testid={testid}
      className={classNames(styles.option, {
        [styles.selected]: selected && !selectedAgent,
        [styles.selectedAgent]: selectedAgent,
      })}
      onClick={onClick}
    >
      <div className={styles.optionContent}>{children}</div>
      {suffix}
    </div>
  );

  return tooltip ? (
    <Tooltip placement="topLeft" title={tooltip}>
      {el}
    </Tooltip>
  ) : (
    el
  );
};
